<script setup>
import * as locales from '@nuxt/ui/locale'
import { Toaster } from 'vue-sonner'
import TelegramHelpButton from './components/App/TelegramHelpButton.vue'

const route = useRoute()
const head = useLocaleHead()
const { t, locale } = useI18n()

const lang = computed(() => locales[locale.value].code)
const dir = computed(() => locales[locale.value].dir)

const title = computed(() =>
  t('layouts-title', { title: route.meta.title ? t(route.meta.title) : '' }),
)

useAnalytics()
</script>

<template>
  <Html
    :lang="lang"
    :dir="dir"
  >
    <Head>
      <Title>{{ title }}</Title>
      <template
        v-for="link in head.link"
        :key="link.hid"
      >
        <Link
          :id="link.hid"
          :rel="link.rel"
          :href="link.href"
          :hreflang="link.hreflang"
          :sizes="link.sizes"
        />
      </template>
      <template
        v-for="meta in head.meta"
        :key="meta.hid"
      >
        <Meta
          :id="meta.hid"
          :property="meta.property"
          :content="meta.content"
        />
      </template>
    </Head>
    <Body>
      <UApp :locale="locales[locale]">
        <NuxtLayout>
          <NuxtLoadingIndicator />
          <NuxtPage />
          <ClientOnly>
            <Toaster position="top-center" />
          </ClientOnly>
          <CookieConsent />
          <TelegramHelpButton v-if="false" />
        </NuxtLayout>
      </UApp>
    </Body>
  </Html>
</template>
